import { render, staticRenderFns } from "./DesksTable.vue?vue&type=template&id=c6e85d30&scoped=true"
import script from "./DesksTable.vue?vue&type=script&lang=js"
export * from "./DesksTable.vue?vue&type=script&lang=js"
import style0 from "./DesksTable.vue?vue&type=style&index=0&id=c6e85d30&prod&lang=scss&scoped=true"
import style1 from "./DesksTable.vue?vue&type=style&index=1&id=c6e85d30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e85d30",
  null
  
)

export default component.exports